import { fetchResourceMap, Res } from '../../state/api';
import { useSession } from '../../state/session';
import { BonusLoggedIn } from '../bonus/BonusLoggedIn';
import { BonusLoggedOut } from '../bonus/BonusLoggedOut';
import { parsePagesQuery, Routing } from '../Routes';
import './BonusPage.css';

export const BonusPage = (): JSX.Element => {
	const { isLoggedIn } = useSession();

	if (!isLoggedIn) return <BonusLoggedOut />;

	return <BonusLoggedIn />;
};

export const bonusRouting: Routing = {
	path(urls) {
		return urls.bonus;
	},
	component: BonusPage,
	requiresAuth: false,
	preload: async (config, _routeMatch, query: string) => {
		const page = parsePagesQuery(query);
		const fetchCmsComponentQuietly = async (params: { slug: string }) => {
			const resourcePath = Res.cmsComponent.uri({ slug: params.slug });
			try {
				return await fetchResourceMap(config, Res.cmsComponent, params, config.cmsContent);
			} catch {
				return { [config.cmsContent + resourcePath]: [] };
			}
		};
		const assets = await Promise.all([
			fetchCmsComponentQuietly({ slug: 'bonus-pitch', ...page }),
			fetchCmsComponentQuietly({ slug: 'bonus-description' }),
		]);
		return Object.assign({}, ...assets);
	},
};
